import { render, staticRenderFns } from "./CreateDlg.vue?vue&type=template&id=70095f74&lang=html&"
import script from "./CreateDlg.vue?vue&type=script&lang=js&"
export * from "./CreateDlg.vue?vue&type=script&lang=js&"
import style0 from "./CreateDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports